import PropTypes from 'prop-types';
import { AppBar, IconButton, Box, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountMenu from './account-menu';
import RelatorioDownloadsMenu from './RelatorioDownloadsMenu';
import { ThemeModeToggle } from '../../../../../../components/v2';

const TopbarV2 = ({ onMenuClick, modeSetting, resolvedMode, onModeSettingChange }) => {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: (theme) => (
          theme.palette.mode === 'dark'
            ? theme.palette.neutral[800]
            : theme.palette.background.paper
        ),
        color: (theme) => theme.palette.text.primary,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton
            aria-label="abrir menu"
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{
              color: (theme) => (
                theme.palette.mode === 'dark'
                  ? theme.palette.common.white
                  : theme.palette.text.primary
              ),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6">Eletropontes</Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ThemeModeToggle
            modeSetting={modeSetting}
            resolvedMode={resolvedMode}
            onModeSettingChange={onModeSettingChange}
          />
          <RelatorioDownloadsMenu />
          <AccountMenu />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopbarV2.propTypes = {
  onMenuClick: PropTypes.func,
  modeSetting: PropTypes.oneOf(['system', 'light', 'dark']).isRequired,
  resolvedMode: PropTypes.oneOf(['light', 'dark']).isRequired,
  onModeSettingChange: PropTypes.func.isRequired,
};

export default TopbarV2;